import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConfigurationConstant } from '../apiConstants/ConfigurationConstant';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  cpaBaseUrl = environment.CPAFee_API_BASE_URL;

  constructor(private httpClient: HttpClient) { }

  getSetting(key: string): Observable<any> {
    const params = new HttpParams().set('key', key);
    return this.httpClient.get<any>(`${this.cpaBaseUrl}/${ConfigurationConstant.Configuration}/${ConfigurationConstant.Setting}`, { params });
  }

  getCutoffDate(): Observable<any> {
    return this.getSetting(ConfigurationConstant.CutoffDateKey);
  }
}
